import { escapeHtml } from '../utils/escape';

export interface ProgressData {
  teamName: string;
  locationsCompleted: number;
  totalLocations: number;
  finished: boolean;
}

export function createProgressCard(data: ProgressData): HTMLElement {
  const card = document.createElement('div');
  card.className = 'card';
  card.style.marginBottom = 'var(--sp-sm)';

  const pct = data.totalLocations > 0
    ? Math.round((data.locationsCompleted / data.totalLocations) * 100)
    : 0;

  card.innerHTML = `
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: var(--sp-sm);">
      <span class="text-title">${escapeHtml(data.teamName)}</span>
      ${data.finished ? '<span class="badge" style="background: var(--success);">ФИНИШ</span>' : ''}
    </div>
    <div class="progress-bar">
      <div class="progress-bar__fill" style="width: ${pct}%; background: ${data.finished ? 'var(--success)' : 'var(--amber)'};"></div>
    </div>
    <div class="text-label" style="color: var(--text-secondary); margin-top: var(--sp-xs);">
      ${data.locationsCompleted} / ${data.totalLocations}
    </div>
  `;

  return card;
}
